<article [class.fullscreen]="isFullscreen" #webcamcontainer>

  <div class="">
    <button class="btn btn-primary btn-lg " (click)="triggerSnapshot()">@if (width <= 600) {
      <span><i
      class="mdi mdi-phone-rotate-landscape"></i> Rotate to
    landscape</span>
    } @if (width>600) {
    <span>Capture Image</span>
  }</button>
  <button class="btn btn-secondary btn-lg " (click)="isFullscreen = isFullscreen ? false : true"><i
  class="mdi mdi-fullscreen"></i></button>
</div>

<section>
  @if (width > 600) {
    <webcam (imageCapture)="handleImage($event)" [width]="width" [height]="height"
    [trigger]="triggerObservable" imageType="image/png" [imageQuality]="1"></webcam>
  }
</section>

</article>
